import { useEffect, useState, type ReactNode } from "react";
import { useProfile, useUpdateProfile } from "../lib/api";
import { Button, Field, Sheet } from "../components/ui";

export function Settings({
  open,
  onClose,
  onSignOut,
  children,
}: {
  open: boolean;
  onClose: () => void;
  onSignOut: () => void;
  children?: ReactNode;
}) {
  const { data: profile } = useProfile();
  const update = useUpdateProfile();
  const [text, setText] = useState("");
  const [injuryOk, setInjuryOk] = useState(false);
  const [untrained, setUntrained] = useState(true);

  useEffect(() => {
    if (!profile) return;
    setText(profile.training_profile);
    setInjuryOk(Boolean(profile.flags.injury_ok));
    setUntrained(profile.flags.untrained !== false);
  }, [profile, open]);

  return (
    <Sheet open={open} onClose={onClose} title="You">
      <div className="grid gap-4">
        <Field label="Training profile — what the PT reads">
          <textarea
            className="field min-h-32 focus:field-focus"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </Field>
        <label className="flex items-center justify-between text-sm">
          <span>
            Hip cleared for lower-body loading
            <span className="block text-xs text-ink-mute">
              Shows squats, hinges, sleds, carries.
            </span>
          </span>
          <input
            type="checkbox"
            checked={injuryOk}
            onChange={(e) => setInjuryOk(e.target.checked)}
          />
        </label>
        <label className="flex items-center justify-between text-sm">
          <span>
            Still building the base
            <span className="block text-xs text-ink-mute">Hides the hardest quests.</span>
          </span>
          <input
            type="checkbox"
            checked={untrained}
            onChange={(e) => setUntrained(e.target.checked)}
          />
        </label>
        {children && <div className="border-t border-border pt-3">{children}</div>}
        <div className="flex justify-between">
          <Button variant="danger" onClick={onSignOut}>
            Sign out
          </Button>
          <Button
            disabled={update.isPending}
            onClick={() =>
              update.mutate(
                { training_profile: text, flags: { injury_ok: injuryOk, untrained } },
                { onSuccess: onClose },
              )
            }
          >
            Save
          </Button>
        </div>
        {update.error && <p className="text-sm text-danger">{(update.error as Error).message}</p>}
      </div>
    </Sheet>
  );
}
